const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '310px',
    textAlign: 'center',
  },

  emptySegmentHeadline: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#596168',
    marginTop: 16,
  },

  text: {
    fontSize: '13px',
    color: '#596168',

    '& > a': {
      textDecoration: 'underline',
    },
  },

  cta: {
    fontWeight: 500,
  },
});

export default styles;
